<script>
  import Label from './Label.svelte';

  export let value;
  export let label = "";
  export let placeholder = "";

  const inputId = `input-${label.trim()}`;

  let focused = false;

  function handleFocusIn() { focused = true; }
  function handleFocusOut() { focused = false; }
  function handleChange(evt) { value = evt.target.value; }

  $: wrapperFocusedClasses = focused ? "border-primary-400 ring-2 ring-primary-300 border-opacity-50" : "border-gray-500 hover:border-gray-600 border-opacity-75";
  $: wrapperClasses = `flex items-center border rounded bg-white h-10 pl-3.5 ${wrapperFocusedClasses}`;
</script>

<div>
  <div class="flex items-center">
    <Label text={label} forId={inputId} />
  </div>
  <div class={wrapperClasses}>
    <input
      id={inputId}
      type="text"
      value={value}
      placeholder={placeholder}
      on:change={handleChange}
      on:focusin={handleFocusIn}
      on:focusout={handleFocusOut}
      class="border-0 ring-0 px-0 bg-transparent w-full cursor-inherit font-sans font-normal placeholder-gray-600 focus:outline-none focus:ring-0 border-primary-400 text-sm text-gray-950"
    />
  </div>
</div>
